var $ = require('jquery');
require('./web/jquery.webslider');
require('fg-frontend/plugins/jquery.universal-pagination');
require('./eshop');
require('./web/highslide-settings');
require('./web/jquery.inline-photogallery');
require('fg-frontend/plugins/jquery.gtmHandler');
require('fg-frontend/plugins/jquery.triggerInViewport');

$('.js_inline-photogallery').inlinePhotogallery();

/********************************************
 * standard pagination
 */
$('.js_pagination').each(function(index, item) {
	var $pag = $(item);
	$(item).universalPagination({
		listSelector: '.media-list',
		itemSelector: '.media',
		lang: window.projectConfig.lang,
		nextClass: 'btn-next',
		nextWrapperClass: 'btn-next-container',
		autoPreloadHistory: true,
		listTopOffset: 15,
		paginationSelector: '.js_pagination'
	});
});


/**
 *  pomocna trida pri zobrazeni RWD menu
 */
$('.toggle-navbar, .main-navbar-collapse .btn-close').on('click', function(){
	$('html').toggleClass('rwd-menu-opened');
});

/**
 *  print click handler
 */
$('.js_print').on('click', function(e){
	window.print();
	e.preventDefault();
});

/**
 * toggle all click handler
 */
$('.js_toggle-all').on('click', function(e){
	var toggleTarget = $(this).data('toggle-target');

	$(toggleTarget).attr('checked','checked');
	e.preventDefault();
});

/**
 * gtm handler
 *
 */
$('[data-gtm-bind]').gtmHandler({'debug': false});
$(document).on('ajaxComplete', function(){
	$('[data-gtm-bind]').gtmHandler({'debug': false});
});

/**
 *  triggers event if subitems of target occur above fold
 */
$('.js_trigger-in-viewport').triggerInViewport();
$(document).on('ajaxComplete', function(){
	$('.js_trigger-in-viewport').triggerInViewport();
});


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function(index, f) {
    $(f);
});




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js